import { SessionCountByProgram, SessionLimitByProgram } from '../../../models/session/SessionUsage'

export const formatDualSessionsText = (
  displayVisitsPerIssuePerYearByProgram: SessionCountByProgram,
  EAPSessionLimitByProgram?: SessionLimitByProgram,
): string => {
  const therapyPerIssuePerYear = displayVisitsPerIssuePerYearByProgram.therapy
  const coachingPerIssuePerYear = displayVisitsPerIssuePerYearByProgram.coaching
  const therapySessionLimit = EAPSessionLimitByProgram?.therapy
  const coachingSessionLimit = EAPSessionLimitByProgram?.coaching

  if (therapyPerIssuePerYear && coachingPerIssuePerYear) {
    return `${therapyPerIssuePerYear} therapy and ${coachingPerIssuePerYear} coaching sessions per issue, per year`
  }

  if (therapyPerIssuePerYear && coachingSessionLimit) {
    return `${therapyPerIssuePerYear} therapy sessions per issue, per year and ${coachingSessionLimit} coaching sessions per year`
  }

  if (coachingPerIssuePerYear && therapySessionLimit) {
    return `${therapySessionLimit} therapy sessions per year and ${coachingPerIssuePerYear} coaching sessions per issue, per year`
  }

  if (therapyPerIssuePerYear) {
    return `${therapyPerIssuePerYear} therapy sessions per issue, per year`
  }

  if (coachingPerIssuePerYear) {
    return `${coachingPerIssuePerYear} coaching sessions per issue, per year`
  }

  return ''
}
